import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="pagination"
export default class extends Controller {

  static targets = ["page"]
  
  // Updates the current url, replacing the page parameter with the given value
  update() {
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.set("page", this.pageTarget.value)
    Turbo.visit(currentUrl.toString(), { action: "replace" })
  }
  
}
